import React, { forwardRef, memo, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import Portal from '../portal/Portal';
import DimmerContent, { DimmerContentProps, DimmerContentUIProps } from './DimmerContent';
import './page-dimmer.css';

export interface PageDimmerUIProps extends DimmerContentUIProps {
  /** Active dimmer */
  uiActive?: boolean;
}

export type PageDimmerProps = PageDimmerUIProps & DimmerContentProps;
const noop = () => {};
/**
 * Full-viewport dimmer rendered in a portal.
 * Use together with DimmerContent (handles background color & content centering).
 */
const PageDimmer = memo(
  forwardRef<HTMLDivElement, PageDimmerProps>((props, ref) => {
    const { uiActive = false, ...other } = props;
    const nodeRef = useRef<HTMLDivElement>(null);

    return (
      <CSSTransition
        in={uiActive}
        timeout={200}
        classNames="transition"
        mountOnEnter
        unmountOnExit
        appear
        enter
        exit
        nodeRef={nodeRef}
      >
        <Portal uiOnRequestClose={noop}>
          <div ref={nodeRef} className="page-dimmer">
            <DimmerContent ref={ref} {...other} />
          </div>
        </Portal>
      </CSSTransition>
    );
  })
);

export default PageDimmer;
